import { GET_USER_HISTORY } from '../../constants/ActionTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const user_history = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_USER_HISTORY}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_USER_HISTORY}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        items: action.payload,
      };
    case `${GET_USER_HISTORY}_FAIL`:
      return {
        ...state,
        loaded: true,
        loading: false,
        items: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default user_history;
